<template>
  <div class="donut-selector-menu">
    <div
      v-for="(option, idx) in props.options"
      :key="`option-${idx}`"
      :tabindex="-1"
      :class="{ 'donut-selector-menu-option': true, 'disabled': option.disabled, 'search-nav-highlighted': idx === props.searchNavIdx }"
      @click.stop="onOptionClick(option)"
    >
      <div class="t">
        <span v-if="option.formatEmojis" v-emoji="option[keyMap.label]" />
        <span v-else>{{ option[keyMap.label] }}</span>
        <template v-if="option[keyMap.description]"><br><span class="t-sm gray ital">{{ option[keyMap.description] }}</span></template>
      </div>
      <i v-if="isSelected(option, props.keyMap)" class="material-icons purple md-20">check</i>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    options: { type: Array, default: () => [] },
    keyMap: { type: Object, default: null },
    isSelected: { type: Function, required: true },
    searchNavIdx: { type: Number, default: null },
  });

  const emit = defineEmits(['onOptionClick']);

  const onOptionClick = (option) => {
    if (!option.disabled) emit('onOptionClick', option);
  };
</script>
